import React from 'react';
import posts from '../data/posts';
import '../styles/About.css';

function About() {
  const aboutData = posts.about;
  
  if (!aboutData) {
    return <div className="about-container main-content"><h1>About</h1><p>Content not found.</p></div>;
  }
  
  return (
    <div className="about-container main-content">
      {aboutData.title && <h1>{aboutData.title}</h1>}
      
      <div className="about-content">
        {aboutData.content.map((item, index) => {
          if (item.type === 'paragraph') {
            return (
              <p 
                key={index} 
                className={`about-paragraph about-${item.align}`}
              >
                {item.text}
              </p>
            );
          } else if (item.type === 'footnote') {
            return (
              <p 
                key={index} 
                className={`about-footnote about-${item.align}`}
              >
                {item.text}
              </p>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}

export default About;

